/* eslint-disable react/prop-types */
import { Box, TableCell, TableRow } from "@mui/material";
import React from "react";
import tableStyle from "../../theme/styles/table";
import { isEmptyObj } from "../../utils/helper";
import { style } from "./styles";
import { getGohonzonType } from "../../utils";

function GohonzonView({ member }) {
  if (isEmptyObj(member) || isEmptyObj(member.memberDetails)) {
    return null;
  }
  const { memberDetails } = member;
  return (
    <TableRow style={tableStyle.tableRow}>
      <TableCell style={{ ...style.Cell, color: "#043D90", fontWeight: "600" }}>
        {memberDetails.memberId}
      </TableCell>
      <TableCell style={style.Cell}>
        {memberDetails.fullName || "-"}
        <br />
        {memberDetails.addressLine1 || "-"}
      </TableCell>
      <TableCell style={style.Cell}>
        {memberDetails.mobileNumber || "-"}
        <br />
        {memberDetails.emailId || "-"}
      </TableCell>
      <TableCell style={style.Cell}>
        {memberDetails.divisionName || "-"}
      </TableCell>
      <TableCell style={style.Cell}>{member.regionName || "-"}</TableCell>
      <TableCell style={style.Cell}>
        {" "}
        <Box style={style.status}>
          {member.status.replace(/_/g, " ") || "-"}{" "}
        </Box>{" "}
      </TableCell>
      <TableCell style={style.Cell}>
        {getGohonzonType(member.gohonzonType)}
      </TableCell>
    </TableRow>
  );
}

export default GohonzonView;
